import React, { useContext } from 'react';
import { CustomFlowbiteTheme, Modal } from 'flowbite-react';
import { MdInfoOutline } from 'react-icons/md';
import { useModal } from '../../../../hooks/ModalContext';
// import { DiscadorContext } from '../../../Discador';
import { formatCPFCNPJ } from '../../../../utils/formatCPFCNPJ';
import { useHibrido } from '../../../../context/HibridoContext';
import { aplicarMascara } from '../../../../utils/mascaraTelefone';

export const ModalInfoDiscador = () => {
  const { onClose, openDiscadorModal } = useModal();
  // const { dadosChamada } = useContext(DiscadorContext);
  const { dadosChamada } = useHibrido();
  // const {} =
  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-50 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full',
      show: {
        on: 'flex bg-gray-900 bg-opacity-5',
      },
    },
  };


  return (
    <>
      <Modal
        show={openDiscadorModal.isOpen}
        // show={true}
        popup={true}
        size={'md'}
        // onClick={() => onClose(false, false, false, true)}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="flex flex-col p-4  text-gray-800">
            <div className="flex w-full items-center justify-center gap-2">
              <MdInfoOutline className="fill-primary" size={24} />
              <h3 className="my-4 text-lg font-semibold text-primary">Informações da Chamada</h3>
            </div>

            <div className="my-2 flex items-center gap-2 text-sm">
              <strong>NOME: </strong>
              <p className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{dadosChamada?.mailing?.data?.nome}</p>
            </div>

            <div className="my-2 flex items-center gap-2 text-sm">
              <strong>CREDOR: </strong>
              <p>
                {dadosChamada?.mailing?.data?.credor}
              </p>
            </div>

            <div className="my-2 flex items-center gap-2 text-sm">
              <strong>CPF/CNPJ: </strong>

              {formatCPFCNPJ(dadosChamada?.mailing?.data?.cgc_cpf || '')}

            </div>

            <div className="my-2 flex items-center gap-2 text-sm">
              <strong>TELEFONE: </strong>

              <p>{aplicarMascara(dadosChamada?.call?.phone)}</p>
            </div>

            <div className="my-2 flex items-center gap-2 text-sm">
              <strong>TIPO LIGAÇÃO: </strong>
              <p>{dadosChamada?.call?.call_mode}</p>
            </div>

            <button
              className="-mb-4 mt-4 rounded-md bg-error p-2 font-semibold text-white"
              onClick={() => onClose(false, false, false, true)}
            >
              Fechar
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
